import bellIcon from '@jetbrains/icons/bell'
import bellCrossedIcon from '@jetbrains/icons/bell-crossed'
import buildTypeIcon from '@jetbrains/icons/buildType'
import buildType20pxIcon from '@jetbrains/icons/buildType-20px'
import buildTypeCompositeIcon from '@jetbrains/icons/buildType-composite'
import cancelIcon from '@jetbrains/icons/cancel'
import caretDown10pxIcon from '@jetbrains/icons/caret-down-10px'
import checkmarkIcon from '@jetbrains/icons/checkmark'
import chevron12pxDownIcon from '@jetbrains/icons/chevron-12px-down'
import chevronDownIcon from '@jetbrains/icons/chevron-down'
import chevronRightIcon from '@jetbrains/icons/chevron-right'
import chevronUpIcon from '@jetbrains/icons/chevron-up'
import closeIcon from '@jetbrains/icons/close'
import commentIcon from '@jetbrains/icons/comment'
import exceptionIcon from '@jetbrains/icons/exception'
import flag12pxIcon from '@jetbrains/icons/flag-12px'
import hourglassIcon from '@jetbrains/icons/hourglass'
import infoIcon from '@jetbrains/icons/info'
import investigationIcon from '@jetbrains/icons/investigation'
import lampIcon from '@jetbrains/icons/lamp'
import moreOptionsIcon from '@jetbrains/icons/more-options'
import muteIcon from '@jetbrains/icons/mute'
import okIcon from '@jetbrains/icons/ok'
import pencilIcon from '@jetbrains/icons/pencil'
import pipelineIcon from '@jetbrains/icons/pipeline'
import playIcon from '@jetbrains/icons/play'
import searchEmptyIcon from '@jetbrains/icons/search-empty'
import settingsIcon from '@jetbrains/icons/settings'
import successIcon from '@jetbrains/icons/success'
import trashIcon from '@jetbrains/icons/trash'
import type {IconType} from '@jetbrains/ring-ui-built/components/icon/icon'
import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'

import brokenArrow36pxIcon from '../../../svg/broken-arrow-36px.svg?react'
import buildFeature20pxIcon from '../../../svg/build-feature-20px.svg?react'
import buildFeatureDisabled20pxIcon from '../../../svg/build-feature-disabled-20px.svg?react'
import osBsdIcon from '../../../svg/os-bsd.svg?react'
import osLinuxIcon from '../../../svg/os-linux.svg?react'
import osMacIcon from '../../../svg/os-mac.svg?react'
import osSolarisIcon from '../../../svg/os-solaris.svg?react'
import osUnixIcon from '../../../svg/os-unix.svg?react'
import osWindowsIcon from '../../../svg/os-windows.svg?react'
import sortingIcon from '../../../svg/sorting.svg?react'
import sparkles36pxIcon from '../../../svg/sparkles-36px.svg?react'

/**
 * Icons rendered by name through the common Icon component that are not part of the
 * build-status automaton. Resolved statically here so no icon name string reaches SvgIcon.
 */
export const passthroughIcons: KeyValue<string, IconType | string> = {
  arrow: caretDown10pxIcon,
  bell: bellIcon,
  'bell-crossed': bellCrossedIcon,
  'broken-arrow-36px': brokenArrow36pxIcon,
  'build-feature-20px': buildFeature20pxIcon,
  'build-feature-disabled-20px': buildFeatureDisabled20pxIcon,
  buildType: buildTypeIcon,
  'buildType-20px': buildType20pxIcon,
  'buildType-composite': buildTypeCompositeIcon,
  cancel: cancelIcon,
  checkmark: checkmarkIcon,
  'chevron-12px-down': chevron12pxDownIcon,
  'chevron-down': chevronDownIcon,
  'chevron-right': chevronRightIcon,
  'chevron-up': chevronUpIcon,
  close: closeIcon,
  comment: commentIcon,
  exception: exceptionIcon,
  'flag-12px': flag12pxIcon,
  hourglass: hourglassIcon,
  info: infoIcon,
  investigation: investigationIcon,
  lamp: lampIcon,
  'more-options': moreOptionsIcon,
  mute: muteIcon,
  ok: okIcon,
  pencil: pencilIcon,
  'os-bsd': osBsdIcon,
  'os-linux': osLinuxIcon,
  'os-mac': osMacIcon,
  'os-solaris': osSolarisIcon,
  'os-unix': osUnixIcon,
  'os-windows': osWindowsIcon,
  pipeline: pipelineIcon,
  play: playIcon,
  'search-empty': searchEmptyIcon,
  settings: settingsIcon,
  sorting: sortingIcon,
  success: successIcon,
  'sparkles-36px': sparkles36pxIcon,
  trash: trashIcon,
}
